/**
 * Menu lateral recolhido ou aberto. Fica gravado no navegador e vale na hora
 * para a casca inteira (menu, barra do topo e área da página), que leem o mesmo
 * estado por aqui.
 */
import { useCallback, useSyncExternalStore } from "react";

export const SIDEBAR_STORAGE_KEY = "siag:sidebar-collapsed";
const EVENTO = "siag:sidebar";

/** Largura do menu em cada estado: as classes Tailwind precisam aparecer inteiras no código. */
export const SIDEBAR_WIDTH = {
  open: { aside: "w-64", main: "ml-64", topbar: "left-64" },
  collapsed: { aside: "w-16", main: "ml-16", topbar: "left-16" },
} as const;

function assinar(avisar: () => void) {
  window.addEventListener(EVENTO, avisar);
  window.addEventListener("storage", avisar);
  return () => {
    window.removeEventListener(EVENTO, avisar);
    window.removeEventListener("storage", avisar);
  };
}

export function setSidebarCollapsed(v: boolean) {
  try { window.localStorage.setItem(SIDEBAR_STORAGE_KEY, v ? "1" : "0"); } catch { /* modo privado: vale só nesta visita */ }
  memoria = v;
  window.dispatchEvent(new Event(EVENTO));
}

/** Sem localStorage (modo privado), o estado fica só em memória. */
let memoria: boolean | null = null;
const snapshot = (): boolean => {
  try { return window.localStorage.getItem(SIDEBAR_STORAGE_KEY) === "1"; } catch { return memoria ?? false; }
};

export function useSidebarCollapsed(): [boolean, (v: boolean) => void, () => void] {
  const collapsed = useSyncExternalStore(assinar, snapshot, () => false);
  const toggle = useCallback(() => setSidebarCollapsed(!snapshot()), []);
  return [collapsed, setSidebarCollapsed, toggle];
}
